import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_8 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={primary}
            d="M515.2,236.8c-16.4-21.8-54.7-42.5-114.1-42.9c-59.4,0.3-97.7,21-114.1,42.9c-13.7,18.2-19.9,43-22.5,66.3
			c-3.6,32.8,0.4,66,10.3,97.5l10.5,33.5c5.3-18.1,6.7-68.9,6.8-82.6c0.1-10.9,17-52.5,16.3-72.1c-2.4-66.4,81.3-44.1,92.7-40.7
			c11.4-3.3,95.1-25.7,92.7,40.7c-0.7,19.6,16.2,61.2,16.3,72.1c0.1,13.7,1.5,64.4,6.8,82.6l10.5-33.5c9.8-31.5,13.9-64.7,10.3-97.5
			C535.1,279.8,528.9,255,515.2,236.8z"
          />
          <path
            fill={secondary}
            d="M493.8,279.5c0,0,54-59-9.8-88.1c0,0-8.1-21.4-50.9-17.8c0,0-23.2-24.7-71.2,5.1c0,0-47.2-6.7-59.5,38.4
			c0,0-33.4,14.5-29.8,47.2c0,0-26.9,17.2-9.7,63.9c0,0,1-34.1,36.5-43.6c35.6-9.4,37.9-21.3,98.7-20.4
			C398.2,264.3,447.9,233.9,493.8,279.5z"
          />
          <g>
            <path
              fill={primary}
              d="M484,191.5c0,0,24.1,37.1-10.5,72c0,0,9.1,5.6,12.7,9.3C486.2,272.7,528.1,216.5,484,191.5z"
            />
            <path
              fill={primary}
              d="M432.7,173.4c0,0,41,31.1,17.4,82.2c0,0,9.1,1.3,14.8,4.1C464.9,259.7,490.9,187.8,432.7,173.4z"
            />
            <path
              fill={primary}
              d="M361.9,178.7c0,0,52.7,11.4,52.9,78.9c0,0,8.3-3.5,18.9-3.2C433.7,254.5,421.7,171.4,361.9,178.7z"
            />
            <path
              fill={primary}
              d="M302.4,217.1c0,0,64.7-8,76.1,47.5c0,0,7.7-0.3,19.8-0.2C398.2,264.3,373.5,184.2,302.4,217.1z"
            />
            <path
              fill={primary}
              d="M272.6,264.3c0,0,44.3-20.4,61.3,8.2c0,0,10.4-4.7,19.9-5.5C353.7,267.1,315.9,214.2,272.6,264.3z"
            />
          </g>
        </g>
        <path
          fill={primary}
          d="M424.4,188.9c7,8.6,11.8,19,14,29.9c2.4-8.7,0.5-18.5-4.9-25.7C431.4,190.3,427.8,187.6,424.4,188.9z"
        />
        <path
          fill={primary}
          d="M476.2,236.3c4.4-3.4,7.2-9,7.1-14.6c-0.1-5.6-2.9-11.1-7.4-14.5C478.4,216.6,478.5,226.7,476.2,236.3z"
        />
        <path
          fill={primary}
          d="M360.2,201c12.5,3.8,23.5,12.6,29.9,24c1.4-4.3-0.4-9-3.1-12.6C381,204.2,370.3,199.6,360.2,201z"
        />
        <path
          fill={primary}
          d="M332.1,226.2c2.9,0,5.8,0.2,8.5,1.3c7.3,3,10.2,11.9,10.2,19.8c-5.4-11.4-18.1-18.8-30.6-18
		c-0.8,0.1-1.9,0.8-1.3,1.4c0-1.1-1.6-1.8-2.4-1C321,226.7,326.7,226.2,332.1,226.2z"
        />
        <path
          fill={primary}
          d="M307.4,273.3c-5.6-0.2-11.1,0.1-16.7,0.9c0,0.7,0,1.4,0,2.1c0-0.7,0-1.5,0-2.2c-1.3,0.7-2.8,0.9-4.2,0.7
		c-0.3,0.7-0.7,1.5-1,2.2c0.4-0.4-0.4-1-1-0.9c-1,0-1.9,0.4-2.7,1c-1.7-0.5-3.6,1-3.6,2.8c0.3-0.8-1-1.1-1.7-0.8
		c-1.4,0.5-2.6,1.5-3.3,2.8c2.7-6.2,8.4-11.1,14.9-12.7C294.8,267.5,302.1,269.1,307.4,273.3z"
        />
      </g>
    </>
  );
};

export default Hair_8;
